// Slack-specific scope groupings for visualization

// Helper to filter scopes present in token
const present = (allScopes, candidates) => {
  const set = new Set(allScopes);
  return candidates.filter((s) => set.has(s));
};

// 1) By Scope Category (functional domains)
const groupSlackByScopeCategory = (scopes) => {
  return {
    'Messaging': present(scopes, ['chat:write', 'im:write', 'mpim:write']),
    'History Access': present(scopes, ['channels:history', 'groups:history', 'im:history', 'mpim:history']),
    'Users & Presence': present(scopes, ['users:read', 'identify']),
    'Channels & Conversations': present(scopes, ['channels:read', 'im:read', 'mpim:read']),
  };
};

// 2) By Permission Type (Read / Write / History / None)
const groupSlackByPermissionType = (scopes) => {
  return {
    'Read-only': present(scopes, ['channels:read', 'users:read', 'im:read', 'mpim:read']),
    'Write-only': present(scopes, ['chat:write', 'im:write', 'mpim:write']),
    'History-only': present(scopes, ['channels:history', 'groups:history', 'im:history', 'mpim:history']),
    'No explicit perms': present(scopes, ['identify']),
  };
};

// 3) By Resource Type
const groupSlackByResourceType = (scopes) => {
  return {
    'Channels': present(scopes, ['channels:read', 'channels:history']),
    'Groups (private channels)': present(scopes, ['groups:history', 'groups.info']),
    'Direct Messages (IM)': present(scopes, ['im:read', 'im:write', 'im:history']),
    'Multi-party IMs (MPIM)': present(scopes, ['mpim:read', 'mpim:write', 'mpim:history']),
    'Users': present(scopes, ['users:read', 'identify']),
    'Messages': present(scopes, ['chat:write']),
  };
};

// 4) By Risk Level
const groupSlackByRiskLevel = (scopes) => {
  return {
    'High Risk': present(scopes, ['chat:write', 'channels:read', 'users:read']),
    'Medium Risk': present(scopes, ['channels:history', 'groups:history', 'im:history', 'mpim:history', 'im:read']),
    'Low Risk': present(scopes, ['identify']),
  };
};

// 5) By User / Team Context
const groupSlackByContext = (scopes) => {
  return {
    'Team (workspace-level)': present(scopes, ['channels:read', 'channels:history', 'groups:history', 'mpim:history', 'users:read', 'identify']),
    'User (user-level)': present(scopes, ['im:read', 'im:write', 'im:history', 'mpim:write', 'chat:write']),
  };
};

export {
  groupSlackByScopeCategory,
  groupSlackByPermissionType,
  groupSlackByResourceType,
  groupSlackByRiskLevel,
  groupSlackByContext,
};




